import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useObservationsSection } from './context/ObservationsSectionContext';
import ObservationsSectionHeader from './components/ObservationsSectionHeader';
import ObservationsSectionBody from './components/ObservationsSectionBody';

const ObservationsSection: FC = () => {
  const { data } = useObservationsSection();

  return (
    <>
      <div className="mb-5">
        <ObservationsSectionHeader />
        <ObservationsSectionBody />
      </div>

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default ObservationsSection;
